/**
 * ero Shop mega menu panel: hovering or focusing a category shows its product cards.
 */
class EroShopPanel extends HTMLElement {
  connectedCallback() {
    this.addEventListener('pointerover', this.#handleEvent);
    this.addEventListener('focusin', this.#handleEvent);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.#handleEvent);
    this.removeEventListener('focusin', this.#handleEvent);
  }

  /** @param {Event} event */
  #handleEvent = (event) => {
    if (!(event.target instanceof Element)) return;

    const category = event.target.closest('[data-ero-panel-target]');
    if (category instanceof HTMLElement) this.activate(category);
  };

  /** @param {HTMLElement} category */
  activate(category) {
    if (category.classList.contains('is-active')) return;

    const targetId = category.dataset.eroPanelTarget;

    for (const item of this.querySelectorAll('[data-ero-panel-target]')) {
      item.classList.toggle('is-active', item === category);
    }

    for (const panel of this.querySelectorAll('[data-ero-panel]')) {
      panel.classList.toggle('is-active', panel.id === targetId);
    }
  }
}

if (!customElements.get('ero-shop-panel')) {
  customElements.define('ero-shop-panel', EroShopPanel);
}
